"use client";

import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { LayoutGrid, List } from "lucide-react";
import { View as ViewType } from "../../types";
import { useLocale } from "@/hooks/useLocale";

export default function View({
    view,
    setView,
}: {
    view: ViewType;
    setView: (view: ViewType) => void;
}) {
    const { dir } = useLocale();
    return (
        <ToggleGroup
            className="gap-0 justify-start md:justify-center"
            dir={dir}
            variant="outline"
            type="single"
            value={view}
            onValueChange={(value: ViewType) => {
                if (value && value !== view) {
                    setView(value);
                }
            }}
        >
            <ToggleGroupItem
                className="bg-background h-9 rounded-e-none border-e-0"
                value={"grid" satisfies ViewType}
            >
                <LayoutGrid className="size-4" />
            </ToggleGroupItem>
            <ToggleGroupItem
                className="bg-background h-9 rounded-s-none border-s-0"
                value={"list" satisfies ViewType}
            >
                <List className="size-4" />
            </ToggleGroupItem>
        </ToggleGroup>
    );
}
